// src/screens/Admin/ReportDetail.js

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api';
import './ReportDetail.css';

import backIcon from '../../assets/backspace-icon.png';

function ReportDetail({ user }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [reportedContent, setReportedContent] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get(`/reports/admin/${id}`);
        setReport(res.data);

        // Fetch reported content preview
        if (res.data.reportedType === 'post') {
          const postRes = await api.get(`/posts/${res.data.reportedId}`);
          setReportedContent(postRes.data);
        } else if (res.data.reportedType === 'product') {
          const productRes = await api.get(`/products/${res.data.reportedId}`);
          setReportedContent(productRes.data);
        }

      } catch (err) {
        console.error('❌ Failed to fetch report detail:', err);
      }
    };
    fetch();
  }, [id]);

  const handleDelete = async () => {
    const confirmed = window.confirm('Are you sure you want to delete this content?');
    if (!confirmed) return;

    try {
      if (report.reportedType === 'post') {
        await api.delete(`/reports/admin/delete-post/${report.reportedId}`);
      } else if (report.reportedType === 'product') {
        await api.delete(`/reports/admin/delete-product/${report.reportedId}`);
      }

      alert(`${report.reportedType} deleted successfully`);
      navigate('/admin/reports');
    } catch (err) {
      console.error('❌ Failed to delete content:', err);
      alert('Failed to delete content. Please try again.');
    }
  };

  if (!report) return <p>Loading...</p>;

  return (
    <div className="reportdetail-scroll-area">
      <div className="reportdetail-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="reportdetail-back-icon"
          onClick={() => navigate('/admin/reports')}
        />
        <h2>Report Detail</h2>
      </div>

      <div className="reportdetail-content">
        <p><strong>Type:</strong> {report.reportedType}</p>
        <p><strong>Reported ID:</strong> {report.reportedId}</p>
        <p><strong>Reporter:</strong> {report.reporterUsername}</p>
        <p><strong>Reported User:</strong> {report.reportedUsername || 'Unknown'}</p>
        <p><strong>Reason:</strong> {report.reason}</p>
        <p><strong>Details:</strong> {report.details}</p>
        <p><strong>Reported On:</strong> {new Date(report.createdAt).toLocaleString()}</p>

        {reportedContent && (
          <div className="report-preview">
            <h3>Reported {report.reportedType === 'post' ? 'Post' : 'Product'} Preview:</h3>

            {report.reportedType === 'post' ? (
              <>
                <p><strong>Author:</strong> {reportedContent.username}</p>
                <p>{reportedContent.content}</p>
                {reportedContent.mediaType === 'image' && reportedContent.media?.[0] && (
                  <img src={reportedContent.media[0]} alt="Reported post preview" className="report-preview-img" />
                )}
              </>
            ) : (
              <>
                <p><strong>Name:</strong> {reportedContent.name}</p>
                <p>{reportedContent.description}</p>
                {reportedContent.media?.[0] && (
                  <img src={reportedContent.media[0]} alt="Reported product preview" className="report-preview-img" />
                )}
              </>
            )}
          </div>
        )}

        <div className="report-actions">
          <button onClick={handleDelete}>🗑️ Delete {report.reportedType}</button>
        </div>
      </div>
    </div>
  );
}

export default ReportDetail;
